import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {khanmigoToolsUpdateBlooketV2Type} from "./__graphql-types__/index.ts";

export const UPDATE_BLOOKET_MUTATION_V2: GqlOperation<
    khanmigoToolsUpdateBlooketV2Type["response"],
    khanmigoToolsUpdateBlooketV2Type["variables"]
> = gqlOp(gql`
    mutation khanmigoToolsUpdateBlooketV2($input: BlooketQuestionSetInput!) {
        updateBlooketQuestionSetV2(input: $input) {
            error {
                code
            }
        }
    }
`);
